import {createActionGroup, emptyProps} from '@ngrx/store';
import {RouterLinkSnackBarConfig, SNACK_BAR_FEATURE_KEY} from '@aviary/store/snack-bar/snack-bar.types';

// For each app to call in an adapter file, using its own RouteName type.
export function createSnackBarActions<RouteNameType extends string = string>() {
  return createActionGroup({
    source: SNACK_BAR_FEATURE_KEY,
    events: {
      'Show': (message: string, action?: string) => ({message, action}),
      'Show Success': (message: string, action?: string) => ({message, action}),
      'Show Error': (message: string, action?: string) => ({message, action}),
      'Show Centered Multiline Success': (lines: string[]) => ({lines}),
      'Show Centered Multiline Error': (lines: string[]) => ({lines}),

      'Show With Router Link': (config: RouterLinkSnackBarConfig<RouteNameType>) => ({config}),
      'Show Success With Router Link': (config: RouterLinkSnackBarConfig<RouteNameType>) => ({config}),
      'Show Error With Router Link': (config: RouterLinkSnackBarConfig<RouteNameType>) => ({config}),

      'Hide': emptyProps()
    }
  });
}

// For Aviary use only.
export const SnackBarActions = createSnackBarActions<string>();
